<p>blank-layout works!</p>

<router-outlet></router-outlet>